import Store from './Store.js';

class Utils {
	// constructor() {
	// }
	genKey = (length) => {
		var result = '';
		var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
		var charactersLength = characters.length;
		for (var i = 0; i < length; i++) {
			result += characters.charAt(Math.floor(Math.random() * charactersLength));
		}
		return result;
	};

	sortArrayOfObjectsBy = (array, field) => {
		return array.sort((a, b) => (a[field] > b[field] ? 1 : -1));
	};

	toArrayOfObjects = (object, id = 'id', name) => {
		if (name) return Object.entries(object).map(([ key, value ]) => ({ [id]: key, [name]: value }));
		return Object.entries(object).map(([ key, value ]) => ({ [id]: key, ...value }));
	};

	log() {
		if (Store.getStoreData('is_debug')) console.log.apply(null, arguments);
	}

	dueDateString(due_date) {
		const curmonth = parseInt(due_date.getMonth());
		const currmonth = curmonth + 1;
		var dueDateStr =
			currmonth >= 10
				? due_date.getFullYear() + '/' + currmonth + '/'
				: due_date.getFullYear() + '/0' + currmonth + '/';
		dueDateStr += due_date.getDate() < 10 ? '0' + due_date.getDate() : due_date.getDate();
		return dueDateStr;
	}

	endOfTheDay(date) {
		date.setHours(23);
		date.setMinutes(59);
		date.setSeconds(59);
		return date;
	}

	selectedOtions(selected_options) {
		return selected_options.reduce((acc, cur) => {
			acc[cur.id] = cur.label;
			return acc;
		}, {});
	}

	getContacts() {
		return this.sortArrayOfObjectsBy(
			this.toArrayOfObjects(Store.getStoreData('contacts'), 'id', 'name'),
			'name'
		);
	}

	getLists(list) {
		return this.sortArrayOfObjectsBy(
			this.toArrayOfObjects(Store.getStoreData('module_config')[list]),
			'title'
		).filter((e) => e.isActive && !e.isDelete);
	}

	getChecklists() {
		// separate 'questions' from 'sets'
		const checklists = Store.getStoreData('module_config')['checklists'];
		let questions = checklists.reduce((acc, cur, i) => {
			acc[cur.id] = Object.keys(cur.questions)
				.filter((question) => cur.questions[question].isActive && !cur.questions[question].isDelete)
				.map((question) => ({
					id: question,
					title: cur.questions[question].title,
					question_id: cur.questions[question].question_id
				})); // convert to array
			return acc;
		}, {});

		const sets = checklists.map((checklist) => {
			delete checklist.questions;
			return checklist;
		});

		return { sets, questions };
	}

	preventNonNumerical(e) {
		e = e || window.event;
		var charCode = typeof e.which == 'undefined' ? e.keyCode : e.which;
		var charStr = String.fromCharCode(charCode);
		if (!charStr.match(/^[0-9]+$/)) e.preventDefault();
	}

	URLsanityCheck(url) {
		if (!url.includes('http')) url = 'http://' + url;
		return url;
	}

	csvStringEncoder(str) {
		return str ? `"${str.replace('"', '""').replace(/,/g, ',').replace(/'/g, "'")}"` : str;
	}

	setEnv(module_name) {
		let api_url = process.env.REACT_APP_API_URL;
		Store.updateStore('module_name', module_name);
		Store.updateStore('base_api_url', process.env.REACT_APP_BASE_URL)
		Store.updateStore('api_url', api_url);
		Store.updateStore('is_admin', false);
		Store.updateStore('is_debug', false);

	}

	//for html textbox
	isBase64(str) {
		//alert('call');
		if (str === '' || str.trim() === '') {
			return false;
		}
		try {
			return btoa(atob(str)) == str;
		} catch (err) {
			return false;
		}
	}

	baseImage() {
		var ImageURL = "data:image/png;base64,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";
		return ImageURL
	  }
}

export default new Utils();
